import { useContext } from 'react';

import { QSetSimilarityResultContext } from './qset-similarity-result-provider';

export function useQSetSimilarityResult() {
  const context = useContext(QSetSimilarityResultContext);

  if (!context) {
    throw new Error('useQSetSimilarityResult must be used within a QSetSimilarityResultProvider');
  }

  return context;
}
